import { Typography } from '@mui/material';
import type { VyIconType } from '@vy/ui-design-system';
import { VyIcon } from '@vy/ui-design-system';
import type { FC, ReactNode } from 'react';

type ConfigurationSectionProps = {
  title: string;
  iconName?: VyIconType;
  children: ReactNode;
};

export const ConfigurationSection: FC<ConfigurationSectionProps> = ({ title, iconName, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
      {iconName && <VyIcon icon={iconName} />}
      <Typography variant="h6">{title}</Typography>
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {children}
    </div>
  </div>
);
